import type { Step } from '../../../../types';
import { Step1, Step2, Step3, Step4, Step5, Step6 } from '../steps';

export const steps = [
  {
    name: 'Step 1: Apply for a loan',
    title: 'Apply for a loan',
    component: Step1,
  },
  {
    name: "Step 2: Applicant's details",
    title: "Applicant's details",
    component: Step2,
  },
  {
    name: 'Step 3: Income and work',
    title: 'Income and work',
    component: Step3,
  },
  {
    name: 'Step 4: Living arrangement',
    title: 'Living arrangement',
    component: Step4,
  },
  {
    name: 'Step 5: Your unsecured loans',
    title: 'Your unsecured loans',
    component: Step5,
  },
  {
    name: 'Step 6: Complete the application',
    title: 'Complete the application',
    component: Step6,
  },
] satisfies Step[];
